module.exports = __webpack_public_path__ + "img/avatar.5259a7ab.png";